const isEnabled = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const isSuperAdmin = (token) =>
  isEnabled(token?.isSuperAdmin) ||
  isEnabled(token?.is_superadmin) ||
  isEnabled(token?.superAdmin);

export const isEnterpriseAdmin = (token) =>
  isEnabled(token?.isEnterpriseAdmin) ||
  isEnabled(token?.is_enterprise_admin) ||
  isEnabled(token?.enterpriseAdmin);

export const isOomeroUser = (token) =>
  isEnabled(token?.isOomero) || isEnabled(token?.is_oomero);

export const isOomeroEnterpriseAdmin = (token) =>
  isOomeroUser(token) && isEnterpriseAdmin(token);

export const hasFeatureAccess = (
  token,
  requiredPermissions = [],
  {
    allowSuperAdmin = true,
    allowEnterpriseAdmin = false,
    allowOomero = false,
  } = {},
) => {
  if (allowSuperAdmin && isSuperAdmin(token)) return true;
  if (allowEnterpriseAdmin && isEnterpriseAdmin(token)) return true;
  if (allowOomero && isOomeroUser(token)) return true;
  if (!requiredPermissions.length) return true;

  const permissions = token?.roles?.permissions || token?.permissions || {};
  return requiredPermissions.some((permission) =>
    isEnabled(permissions?.[permission]),
  );
};
